import React, { useState, useEffect, useRef } from 'react';

const nombresMujer = ['Lady','Ana','Jimena','Adriana','Carol','Ana Maria','Maria','Mafe','Julieth','Liliana','Lilia','Monica','Luz','Liz','Maria', 'Fernanda', 'Samanta', 'Sofía', 'Luisa', 'Juanita', 'Angélica', 'Esteban', 'Diana', 'Luisa', 'Andrea', 'Camila', 'Camila', 'Maria', 'Sandra', 'Maria', 'Natalia', 'Maria', 'Patricia', 'Maria', 'Laura', 'Maria', 'Martha', 'Andrés', 'Catalina', 'Maria', 'Viviana', 'Maria', 'Alejandra', 'Alejandra'];
const nombresHombres = ['Juan', 'Carlos', 'José', 'Miguel', 'Andrés', 'Luis', 'Javier', 'Francisco', 'Pedro', 'Jorge', 'Antonio', 'Roberto', 'Ricardo', 'Raúl', 'Eduardo', 'Fernando', 'Santiago', 'Manuel', 'Alejandro', 'Enrique', 'Diego', 'Héctor', 'Ángel', 'Rafael', 'Daniel', 'Sebastián', 'Víctor', 'Mauricio', 'Felipe', 'Ramón', 'Martín', 'Gabriel', 'Oscar', 'Alberto', 'Rubén', 'Pablo', 'Rodrigo', 'Cristian', 'Gustavo', 'Marcos', 'Ignacio', 'Simón', 'Iván'];
const nombresAmbos = nombresMujer.concat(nombresHombres);

const apellidos = ['Escobar','Rangel','Isabel', 'Olarte', 'Bustamante', 'Martínez','Martínez','Martínez','Martínez','Martínez','Martínez', 'Jimenez', 'Jimenez', 'Jimenez', 'González','González','González', 'Rodriguez','Rodriguez','Rodriguez','Rodriguez', 'Ortiz', 'Herrera', 'Herrera', 'Torres', 'Suarez', 'Torres', 'Cortés', 'Jiménez', 'Patricia', 'Elena', 'Bernal', 'Mejia', 'Calderon', 'Calderon', 'Ortiz', 'Mesa', 'De Jesus', 'Gómez', 'Perea', 'Cuellar', 'Morales', 'Lara', 'Corredo', 'Cuesta', 'Umaña','Riaño','Forero','Fonseca','Arias','Puentes','Casas','Cubides','Castillo','Haumada','Angarita','Martinez','Avila'];
const ciudades = ['Bogotá','Bogotá','Bogotá','Bogotá','Bogotá','Bogotá','Bogotá','Bogotá','Bogotá','Bogotá','Bogotá','Bogotá','Bogotá','Bogotá','Medellin','Medellin','Medellin','Medellin','Medellin','Medellin','Medellin','Medellin','Medellin','Medellin','Medellin','Medellin', 'Cali','Cali','Cali','Cali','Cali','Cali','Cali','Cali', 'Cucuta', 'Guajira', 'Santa Marta', 'Manizales', 'Valledupar', 'Tunja', 'Leticia', 'Florencia', 'Quibdó', 'Arauca', 'San Andrés', 'San José del Guaviare'];

export default function SellsAlerts({product_imgs, position = 'top-right', fillSpace = false, disabled = false, gender = 'BOTH'}) {

    const [people, setPeople] = useState(generarPersonas(100));
    function generarPersonaAleatoria() {
    //   const nombre = nombres[Math.floor(Math.random() * nombres.length)];
      let nombre = ""
      if (gender === "WOMEN") {
        nombre = nombresMujer[Math.floor(Math.random() * nombresMujer.length)];
      } else if (gender === "MEN") {
        nombre = nombresHombres[Math.floor(Math.random() * nombresHombres.length)];  
      } else {
        nombre = nombresAmbos[Math.floor(Math.random() * nombresAmbos.length)];
      }

      const apellido = apellidos[Math.floor(Math.random() * apellidos.length)];
      const ciudad = ciudades[Math.floor(Math.random() * ciudades.length)];
      const timeAgo = Math.floor(Math.random() * 60) + 1; // Genera un número entre 1 y 60
      const timeUnit = Math.random() > 0.5 ? "Minutos" : "Segundos"; // Selecciona aleatoriamente entre "Minutos" y "Segundos"
  
      return { name: `${nombre} ${apellido}, en ${ciudad}`, timeAgo, timeUnit };
    }
  
    function generarPersonas(cantidad) {
      return Array.from({ length: cantidad }, generarPersonaAleatoria);
    }

    const [show, setShow] = useState(false);
    const [currentPerson, setCurrentPerson] = useState(null);
    // Agrega un estado para manejar la imagen actual
    const [currentImg, setCurrentImg] = useState('');
    const alertContainerRef = useRef(null); // Ref para el contenedor del alerta

    useEffect(() => {
        const interval = setInterval(() => {
            // Selecciona una persona aleatoriamente
            const randomIndexPerson = Math.floor(Math.random() * people.length);
            const randomPerson = people[randomIndexPerson];
            setCurrentPerson(randomPerson);

            // Selecciona una imagen aleatoriamente
            if(product_imgs?.length > 0){
                const randomIndexImg = Math.floor(Math.random() * product_imgs.length);
                const randomImg = product_imgs[randomIndexImg];
                setCurrentImg(randomImg);
            }

            setShow(true);
            setTimeout(() => setShow(false), 8000); // Se oculta después de x segundos
        }, getRandomInterval());

        return () => clearInterval(interval);
    }, [people, product_imgs]);

    const getRandomInterval = () => {
        return Math.floor(Math.random() * (16000 - 8000 + 1)) + 8000; // Intervalo aleatorio entre alerts
    };

    // Calcula el estilo basado en los props
    const getStyle = () => {
        let baseStyle = {
            // zIndex: 1000,
            // padding: '10px',
            // marginBottom: '10px',
            // boxShadow: '0 0 10px rgba(0,0,0,0.1)',
        };
        
        if (fillSpace) {
            // const { width, height } = alertContainerRef.current?.getBoundingClientRect() || { width: 0, height: 0 };
            // baseStyle = { ...baseStyle, width: `${width}px`, height: `${height}px` };

            baseStyle = { ...baseStyle, width: `100%` };
        } else {
            const positions = {
                'top-right': { top: '10px', right: '10px' },
                'top-left': { top: '10px', left: '10px' },
                // Añade más posiciones según necesites
            };
            baseStyle = { ...baseStyle, position: 'fixed', ...positions[position] };
        }

        return baseStyle;
    };

    if (disabled) {
        return null
    }

    return (
        // <div className="alert-container" style={{ position: 'fixed', top: '10px', right: '10px', zIndex: 1000 }}>
        <div className="alert-container" style={getStyle()}>
            {show && currentPerson && (
                <div className="alert" style={{ background: 'white', padding: '10px', boxShadow: '0 0 10px rgba(0,0,0,0.1)', marginBottom: '10px' }}>
                    <div className='d-flex'>
                        <img loading="lazy" style={{objectFit: "cover", maxWidth: "50px", maxHeight: "50px", borderRadius: "5px", marginRight: "10px"}} 
                            src={currentImg} alt=""
                        />
                        <div>
                            <strong>{currentPerson.name}</strong>
                            <p>Compró este producto</p>
                            <p>Hace {currentPerson.timeAgo} {currentPerson.timeUnit}</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

